import NotificationsPopover from './notifications-popover';
import type { NotificationsPopoverProps } from './notifications-popover';

export { NotificationsPopoverProps };
export default NotificationsPopover;
